import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const PairDevicesSuccess: FC = () => {
  const { t } = useTranslation();

  return (
    <StatusMessageBox
      type="success"
      message={t('common:pages.rfids.pair_devices.success')}
    />
  );
};

export default PairDevicesSuccess;
